module.exports = "/10/1-input-output-stream-c/index.html.00778ce867833da4b30657a62f30af1e.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/35321.md
 ** module id = 586
 ** module chunks = 0
 **/